// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1Kclo","errors":"Errors_errors__TvS9K"};